import { FC } from 'react';
import { FormAsyncSelectField, FormAsyncSelectFieldProps, lt } from '@mews/framework';
import { Company } from '@mews-commander/data-access';
import { DropdownItem, Typography } from '@optimus-web/core';
import { useAsyncSelectFieldControls } from '../useAsyncSelectFieldControls';
import { useSearchCompaniesQuery } from './useSearchCompaniesQuery';
import { useGetAllCompaniesQuery } from './useGetAllCompaniesQuery';

const renderData = (companies: Company[]): React.ReactNode =>
    companies.map(({ id, name }) => <DropdownItem key={id} value={id} label={name} />);

interface CompanySearchFieldProps extends Omit<FormAsyncSelectFieldProps<Company>, 'useDataQuery' | 'renderData'> {}

export const CompanySearchField: FC<CompanySearchFieldProps> = (props: CompanySearchFieldProps) => {
    const { name, multiselect } = props;

    const { selectedItems, addSelectedItem, ...controls } = useAsyncSelectFieldControls<Company>({
        useSearchQuery: useSearchCompaniesQuery,
        useGetDefaultQuery: useGetAllCompaniesQuery,
        name,
        multiselect,
    });

    return (
        <FormAsyncSelectField
            clearable
            label={lt('Company')}
            placeholder={lt('SearchByName')}
            emptyMessage={
                <Typography textStyle="bodyMediumStrong" variant="tertiary" as="div">
                    {lt('NoResultsForSearch')}
                </Typography>
            }
            defaultOptions={renderData(selectedItems)}
            renderData={renderData}
            {...controls}
            {...props}
        />
    );
};
